<template>
	<v-dialog v-model="visible" max-width="360">
		<template v-slot:activator="{ on, attrs }">
			<slot v-bind="{ on, attrs }" />
		</template>
		<v-card :loading="loading">
			<v-card-title class="headline">Are you sure?</v-card-title>

			<!-- eslint-disable-next-line -->
			<v-card-text v-html="text" />

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="rust-red darken-1" text @click="close(false)"
					>Cancel</v-btn
				>
				<v-btn color="ocean darken-1" outlined @click="close(true)"
					>Confirm</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from "vuex";

import strings from "@/utils/strings";

import { DEVICE_CLASS_ROOM } from "@/utils/k4util";

export default {
	data: function() {
		return {
			device: null,
			visible: false,
			loading: false,

			resolve: null,
		};
	},

	computed: {
		text() {
			if (!this.device) {
				return "";
			} else if (this.device.cls === DEVICE_CLASS_ROOM) {
				return strings.dialogs.removeRoom.body;
			}
			return strings.dialogs.removeDevice.body;
		},
	},

	methods: {
		...mapActions({
			remove: "controller/nodes/remove",
		}),

		pop(item) {
			this.device = item;
			this.visible = true;
			return new Promise(resolve => {
				this.resolve = resolve;
			});
		},

		async close(confirmed) {
			if (!confirmed) {
				this.visible = false;
				if (this.resolve) this.resolve(false);
				return;
			}

			this.loading = true;
			try {
				if (this.resolve) {
					await this.remove(this.device);
				}
			} catch (e) {
				this.$emit("error", e);
			} finally {
				this.loading = false;
				this.visible = false;
			}
		},
	},
};
</script>
